import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { PurchaseService } from '../../../../../core/services/purchase.service';
import { debounceTime, filter, switchMap } from 'rxjs';
import { CommonModule } from '@angular/common';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { TranslatePipe } from '../../../../../shared/pipes/translate.pipe';
import { TranslationService } from '../../../../../core/services/translation.service';

@Component({
  selector: 'app-purchase',
  imports: [ReactiveFormsModule, CommonModule, TranslatePipe],
  templateUrl: './purchase.html',
  styleUrl: './purchase.css',
})
export class Purchase implements OnInit {
  searchControl = new FormControl('');
  results: any[] = [];
  loading = false;
  isExporting = false;
  loadingLottery = true;
  lotteryImage = '';

  @ViewChild('previewContainer') previewContainer!: ElementRef;

  constructor(
    private router: Router,
    private purchaseService: PurchaseService,
    private cdr: ChangeDetectorRef,
    private translationService: TranslationService,
  ) {}

  ngOnInit(): void {
    this.loadLotteryImage();

    this.searchControl.valueChanges
      .pipe(
        debounceTime(300),
        filter((value): value is string => !!value),
        switchMap((value: string) => {
          this.loading = true;
          return this.purchaseService.orderByInv(value);
        })
      )
      .subscribe({
        next: (res: any) => {
          this.loading = false;
          
          this.results = res?.result ? [res.result] : [];
          this.cdr.detectChanges();
        },
        error: (err) => {
          this.loading = false;
          console.error(err);
        },
      });
  }

  exportToPDF() {
    if (this.results.length === 0) return;
    
    const data = this.results[0];
    const payload = {
      invNo: data.invoiceno,
      ticket: data.payment.ticket.map((t: any) => ({
        alphabet: t.alphabet,
        number: t.number
      }))
    };

    this.isExporting = true;
    this.purchaseService.generatePDF(payload).subscribe({
      next: (blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `Ticket_${payload.invNo}.pdf`;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
        this.isExporting = false;
        this.cdr.detectChanges();
      },
      error: (err) => {
        console.error('PDF generation failed', err);
        this.isExporting = false;
        this.cdr.detectChanges();
      }
    });
  }

  loadLotteryImage() {
    this.loadingLottery = true;
    this.purchaseService.getCurrentMonthLottery().subscribe({
      next: (res: any) => {
        if (res.returncode === '300' && res.data) {
          this.lotteryImage = res.data.image;
          this.loadingLottery = false;
          this.cdr.detectChanges();
        } else {
          this.loadingLottery = false;
        }
      },
      error: (err) => {
        console.error('Failed to load lottery image', err);
        this.loadingLottery = false;
      }
    });
  }

  currentLang() {
    return this.translationService.currentLang();
  }

  setLanguage(lang: 'en' | 'mm') {
    this.translationService.setLanguage(lang);
  }

  back() {
    this.router.navigate(['/']);
  }
}
